import { render, staticRenderFns } from "./FormOrderPreparationIstructions.vue?vue&type=template&id=83e4fdf8&"
import script from "./FormOrderPreparationIstructions.vue?vue&type=script&lang=ts&"
export * from "./FormOrderPreparationIstructions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports